import BonusButton from '../../components/BonusButton';
import ButtonRed from '../../components/ButtonRed';
import StyleCheckbox from '../../components/StyleCheckbox';
import StyleInput from '../../components/StyleInput';

function FirstFormStep({ onClickButton = () => {} }) {
  return (
    <div id='form-step'>
      <div className='group-row'>
        <BonusButton labelText='Mail' active={true} onClick={() => {}} />
        <BonusButton labelText='Socials' active={false} onClick={() => {}} />
      </div>
      <div className='group-row'>
        <StyleInput type='email' placeholder='E-mail' />
      </div>
      <div className='group-row'>
        <StyleInput type='password' placeholder='Password' />
      </div>
      <div className='group-row'>
        <StyleCheckbox id='years' />
        <label className='checkbox-label'>I am 18 years old</label>
      </div>
      <div className='group-row'>
        <StyleCheckbox id='terms' />
        <label className='checkbox-label'>
          I agree to the <span className='link'>Terms & Conditions</span>
        </label>
      </div>
      <div className='group-row'>
        <ButtonRed labelText='Sign Up' onClick={onClickButton} fontSize={24} />
      </div>
      <div className='spacer-16'>
        <div className='group-center'>
          <span>Already have an account?</span>
          <span className='link'>Sign in</span>
        </div>
        <div className='group-center'>
          <span>Forgot your password?</span>
          <span className='link'>Restore</span>
        </div>
      </div>
    </div>
  );
}

export default FirstFormStep;